import resolveModelContextWindowTokens from '@shared/pieve/resolveModelContextWindowTokens.js';
import { resolvePieveModelId } from '@shared/pieve/modelSelection.js';

const getModelContextWindowTokens = (modelId) => {
  return resolveModelContextWindowTokens(resolvePieveModelId(modelId));
};

export default getModelContextWindowTokens;
